// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MCZF9","footer_ul":"Footer_footer_ul__TwOV3","socialMedia":"Footer_socialMedia__uKbP9"};